import Vue from 'vue'
import Router from 'vue-router'
import store from '../store/index'

//Web Imports
import Web from '@/views/Web/Web'
import Home from '@/views/Web/Home'

//Plugin Imports
import Plugin from '@/views/Plugin/Plugin'
import PluginNav from '@/views/Plugin/PluginNav'
import CustomerList from '@/views/Plugin/CustomerList/CustomerList'
import CustomerProfile from '@/components/CustomerProfile/CustomerProfile'
//Dealsheet View
import Dealsheet from '@/views/Dealsheet/Dealsheet';
import DealsheetHome from '@/views/Dealsheet/DealsheetHome'

//Splash View
import Splash from '@/components/Splash/Splash.vue'

import {
  webAuth
} from '../../src/auth/index.js'
Vue.use(Router)

export default new Router({
  routes: [{
      path: '/',
      name: 'Web',
      component: Web,
      beforeEnter: onChange,
      children: [{
        name: 'Home',
        component: Home,
        path: ''
      }]
    },
    {
      path: '/plugin',
      name: 'Plugin',
      component: Plugin,
      props: {
        isMobile: true
      },
      children: [{
          name: 'Plugin.PluginNav',
          component: PluginNav,
          path: ''
        },
        {
          name: 'Plugin.CustomerList',
          component: CustomerList,
          path: 'customerList',
          props: {
            isCustomerList: true
          }
        },
        {
          name: 'Plugin.CustomerProfile',
          path: 'customerProfile',
          component: CustomerProfile,
          props: (route) => ({
            customerObj: {
              CrmCustomerID: route.query.crmCustomerId,
              PersonaID: route.query.personaId,
              PersonaAccountID: route.query.personaAccountId,
              PersonaPlatformId: route.query.personaPlatformId,
            },
            user: store.getters.User, 
            isMobile: true
          })
        }
      ]
    },
    {
      path: '/dealsheet',
      name: 'Dealsheet',
      component: Dealsheet,
      children: [{
        name: 'Dealsheet.Home',
        component: DealsheetHome,
        path: ''
      }]
    },
    {
      path: '/splash',
      component: Splash,
      name: 'Splash'
    }
  ]
})

function onChange(to, from, next) {
  webAuth.getUser().then(function (user) {
    if (user && !user.expired) {
      webAuth.user.isLoggedIn = true;
      next();
    } else {
      webAuth.user.isLoggedIn = false;
      webAuth.login();
    }
  })
}



// WEBPACK FOOTER //
// ./src/router/index.js